import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=10710b50&scoped=true"
import script from "./GameList.vue?vue&type=script&lang=ts"
export * from "./GameList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GameList.vue?vue&type=style&index=0&id=10710b50&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "10710b50",
  "c2ca2e92"
  
)

export default component.exports